export default (params) => ({
  trigger: {
    name: 'anchor_bar.select_subcategory_of_anchor_bar',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      redirect: {
        type: 'string',
      },
    },
    event: {
      name: 'select_anchor_bar',
      params: {
        sub_feature: null,
      },
    },
  },
});
